import React, { Component } from 'react';
import { Card, Row, Col } from 'antd';
import { inject, observer } from 'mobx-react';

import MetricWithProgress from './MetricWithProgress';
import Metric from './Metric';
import AirIcon from '../../../../../common/icons/AirIcon';
import CarIcon from '../../../../../common/icons/CarIcon';

import './HealtCarCard.css';
import moment from 'moment';
import GraphLineIcon from '../../../../../common/icons/GraphLineIcon';
import BatteryHistory from './BatteryHistory';

@inject('translationsStore', 'commonStore')
@observer
export default class HealtCarCard extends Component {
  constructor(props) {
    super(props);
    this.state = { visibleBatteryHistory: false };
  }

  onShowBatteryHistory = () => {
    this.setState({ visibleBatteryHistory: true });
  };

  render() {
    const { translationsStore, commonStore, ignitionState, ignitionStateUpdatedAt, lastConnection, kmPerDay } = this.props;
    const ignitionLabel = translationsStore.translate(`carView.car.ignitionState.${ignitionState}`);
    const hasKmPerDay = typeof kmPerDay === 'number' && !Number.isNaN(kmPerDay);
    const roundedKmPerDay = hasKmPerDay ? Math.round(kmPerDay) : null;
    const formattedLastConnection = lastConnection
      ? {
          date: moment(lastConnection).format(commonStore.longDateFormat.L),
          time: moment(lastConnection).format(commonStore.longDateFormat.LT)
        }
      : null;
    return (
      <Card className="HealtCarCard" style={this.props.style}>
        <Row type="flex" className="header" align="middle" justify="space-between">
          <Col className="title">{translationsStore.translate('carView.healtStatus.title')}</Col>
          <Col className="headerMeta">
            <div className="ignitionState">{ignitionLabel}</div>
            {ignitionStateUpdatedAt && (
              <div className="ignitionSince">
                <span className="label">{translationsStore.translate('since')}</span>
                <span>{moment(ignitionStateUpdatedAt).format(commonStore.longDateFormat.L)}</span>
                <span>{moment(ignitionStateUpdatedAt).format(commonStore.longDateFormat.LT)}</span>
              </div>
            )}
          </Col>
        </Row>
        <div className="container">
          <div className="metricsStack">
            <div className="metricCard primaryMetric">
              <MetricWithProgress
                name="battery"
                iconMainColor="#EE9A0E"
                icon={<AirIcon type="battery-warning" />}
                steps={[9.5, 10]}
                upperBound={15}
                metric={this.props.battery}
                uom="V"
                translate={this.props.translationsStore.translate.bind(translationsStore)}
                strokeColors={['red', 'orange', 'green']}
                locale={commonStore.dateFnsLocale}
              />
            </div>

            <div className="metricCard">
              {this.props.showGpsOdometer ? (
                <Metric
                  name="gpsOdometer"
                  icon={<AirIcon type="km" style={{ color: 'blue' }} />}
                  metric={{ value: (this.props.gpsOdometer || {}).value + this.props.initialOdometer, updatedAt: (this.props.gpsOdometer || {}).updatedAt }}
                  uom="Km"
                  translate={this.props.translationsStore.translate.bind(translationsStore)}
                  locale={commonStore.dateFnsLocale}
                />
              ) : (
                <Metric
                  icon={<AirIcon type="km" style={{ color: '#7acc00' }} />}
                  name="odometer"
                  metric={this.props.odometer}
                  uom="Km"
                  translate={this.props.translationsStore.translate.bind(translationsStore)}
                  locale={commonStore.dateFnsLocale}
                />
              )}
            </div>

            <div className="metricCard kmPerDayCard">
              <div className="kmPerDayContent">
                <div className="metricInfo">
                  <CarIcon className="metricIcon" />
                  <div className="metricLabel">{translationsStore.translate('carView.IssuesCard.kmPerDay')}</div>
                </div>
                <div className="metricValue">
                  {hasKmPerDay ? (
                    <>
                      <span>{roundedKmPerDay.toLocaleString()}</span>
                      <span className="unit">km</span>
                    </>
                  ) : (
                    <span>{translationsStore.translate('carView.healtStatus.unknown')}</span>
                  )}
                </div>
              </div>
              
            </div>

      
             {/*  <Metric
                icon={<AirIcon type="oil" style={{ fontSize: '10px' }} />}
                name="oilLevel"
                metric={this.props.oilLevel}
                style={{ visibility: 'hidden' }}
                uom="mm"
                translate={this.props.translationsStore.translate.bind(translationsStore)}
                locale={commonStore.dateFnsLocale}
              /> */}
          
          </div>
        </div>
        <div className="infoRow">
          <div className="infoBlock">
            <div className="label">{translationsStore.translate('carView.IssuesCard.lastConnection')}</div>
            <div className="value">
              {formattedLastConnection ? (
                <>
                  <span>{formattedLastConnection.date}</span>{' - '}
                  <span>{formattedLastConnection.time}</span>
                </>
              ) : (
                <span>—</span>
              )}
            </div>
          </div>
        </div>
      </Card>
    );
  }
}
